import React from 'react';

const WhiteButtonMenu = ({ text, onClick, isActive = false, className = "" }) => {
  return (
    <button
      onClick={onClick}
      className={`
        relative flex-none px-5 py-3 text-sm transition-all duration-200 whitespace-nowrap
        ${isActive
          ? 'text-white font-semibold tab-active'
          : 'text-white/50 font-medium hover:text-white/80'
        }
        ${className}
      `}
    >
      {text}
    </button>
  );
};

export default WhiteButtonMenu;
